import { getSupplierGenericProperties } from '@bridebook/web/app-basic/lib/analytics/helper';
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import {
  getSupplier,
  getSupplierLoaded,
  getSupplierTier,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { TLoggedOutPageClickedSection } from '@bridebook/web/app-shared/lib/types';
import { isSupplierPage, usePathWithoutMarket } from '@bridebook/web/lib/utils/url';

const useSignAnalytics = (
  clickedLocation: string,
  clickedSection?: TLoggedOutPageClickedSection,
  cta?: string,
) => {
  const supplier = useSelector(getSupplier);
  const supplierLoaded = useSelector(getSupplierLoaded);
  const dispatch = useDispatch();
  const supplierTier = useSelector(getSupplierTier);
  const pathname = usePathWithoutMarket();

  const supplierGenericProps = useMemo(() => {
    if (!supplierLoaded && !isSupplierPage(pathname)) return null;
    return getSupplierGenericProperties({ supplier, supplierTier });
  }, [pathname, supplier, supplierLoaded, supplierTier]);

  return useCallback(() => {
    dispatch(
      clickedOnLoggedOutPage({
        clickedLocation,
        clickedSection,
        cta,
        ...supplierGenericProps,
      }),
    );
  }, [clickedLocation, clickedSection, cta, dispatch, supplierGenericProps]);
};

export default useSignAnalytics;
